export default __webpack_public_path__ + "assets/8e7370fd1e040471951be8d368a85d58.svg";